import { FC } from 'react';
import classNames from './AvatarIcon.module.css';

export const AvatarIcon: FC = () => {
  return (
    <div className={classNames.iconRoot} />
  );
};
